module.exports = __webpack_public_path__ + "img/title02.2d9f5048.png";